import { useTheme } from '@mui/material'
import { SnapshotDataType } from './PayoffChart'
import { memo } from 'react'
import { callColorCumulative, putColorCumulative } from '../multiStikeChart/styles'
import { formatLargeNumber } from '../../util/screener'
import { green, red } from '../../assets/colors'
import { useSelector } from 'react-redux'
import { selectPayoffPreferences } from '../../selectors/user'

export type Props = {
    snapshotData: SnapshotDataType
}

const PayoffMetaDataDisplay = ({ snapshotData }: Props) => {
    const { showOiBars = true } = useSelector(selectPayoffPreferences)
    const style = {
        fontSize: '13px'
    }
    const theme = useTheme()

    return (
        snapshotData ? <>
            <div>
                <>
                    <span className="series-meta-name"
                          style={{ fontSize: '9px', color: theme.palette.text.secondary, textAlign: 'left' }}><span
                        style={{ ...style, color: theme.palette.text.primary, textAlign: 'left' }}>{snapshotData.time}</span></span>
                </>
                {
                    showOiBars ? 
                    <span style={{display: 'inline-block', minWidth: '100px', textAlign: 'right'}}>
                        {/* <span className="series-meta-label"
                            style={{ fontSize: '9px', color: theme.palette.text.secondary }}>CALL OI</span> */}
                        <span className="series-meta-value" style={{ ...style, color: callColorCumulative, marginRight: '10px' }}>{formatLargeNumber(snapshotData.oiData[0]) ?? '-'}</span>
                        <span className="series-meta-value" style={{ ...style, color: callColorCumulative, marginRight: '10px' }}>{'δ ' + (formatLargeNumber(snapshotData.deltaData[0]) ?? '-')}</span>

                        {/* <span className="series-meta-label"
                            style={{ fontSize: '9px', color: theme.palette.text.secondary }}>PUT OI</span> */}
                        <span className="series-meta-value" style={{ ...style, color: putColorCumulative }}>{formatLargeNumber(snapshotData.oiData[1]) ?? '-'}</span>
                        <span className="series-meta-value" style={{ ...style, color: putColorCumulative }}>{'δ ' + (formatLargeNumber(snapshotData.deltaData[1]) ?? '-')}</span>
                    </span> : null
                }
            </div>
            <div>
                <span className="series-meta-name" style={{ fontSize: '9px', minWidth: '30px', display: 'inline-block', color: theme.palette.text.secondary }}>P&L </span>
                <span style={{display: 'inline-block', minWidth: '100px', textAlign: 'right'}}>
                    <span style={{ fontSize: '9px', color: theme.palette.text.secondary}}> EXPIRY </span>
                    <span className="series-meta-value" style={{
                        ...style,
                        color: snapshotData.pnlData?.color ?? ''
                    }}>{Number.isFinite(snapshotData.pnlData?.value) ? snapshotData.pnlData?.value.toFixed(2) : '-'}</span>
                    <span style={{ fontSize: '9px', color: theme.palette.text.secondary}}> TARGET </span>
                    <span className="series-meta-value" style={{
                        ...style,
                        color: Number.isFinite(snapshotData.tradingDayPnlData?.value) ? snapshotData.tradingDayPnlData?.value>=0 ? green : red : 'inherit'
                    }}>{Number.isFinite(snapshotData.tradingDayPnlData?.value) ? snapshotData.tradingDayPnlData?.value.toFixed(2) : '-'}</span>
                </span>
            </div>
            {/* <div>
                <span className="series-meta-name" style={{ fontSize: '9px', minWidth: '90px', display: 'inline-block', color: theme.palette.text.secondary }}>TARGET DAY P&L </span>
                <span style={{display: 'inline-block', minWidth: '100px', textAlign: 'right'}}>
                    <span className="series-meta-value" style={{
                        ...style,
                        color: Number.isFinite(snapshotData.tradingDayPnlData?.value) ? snapshotData.tradingDayPnlData?.value>=0 ? green : red : 'inherit'
                    }}>{Number.isFinite(snapshotData.tradingDayPnlData?.value) ? snapshotData.tradingDayPnlData?.value.toFixed(2) : '-'}</span>
                </span>
            </div> */}
        </> : null
    )
}

export default memo(PayoffMetaDataDisplay)